<template>
  <div>
    <v-card max-width="300" elevation="0">
      <v-card-text class="pa-0">
        <v-card-text class="color-wallet" fill-dot rigth>
          <span style="color: #FFFFFF">{{
            getAmountToSetEnterprise
              ? new Intl.NumberFormat("de-DE").format(getAmountToSetEnterprise) + " Kzs"
              : ""
          }}</span>
        </v-card-text>
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="cellphone"
            :rules="cellphoneRules"
            label="Telefone Móvel"
            required
            filled
            placeholder="Telefone móvel registado no Express"
            ref="refrence"
          ></v-text-field>
          <v-card-actions>
            <v-btn
              color="deep-purple lighten-2"
              text
              block
              @click="setConfirm"
              :loading="loading"
            >
              <v-icon>mdi-plus</v-icon>
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapHelper } from "../../../../store/helper";

export default {
  name: "FormConfirmCreditWalletEnterprise",
  data: () => ({
    disabled: false,
    showNotify: false,
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    cellphone: "",
    cellphoneRules: [
      v => !!v || "Telefone é requerido",
      v => /^[9]+[1-9]\d{7}$/.test(v) || "Telefone inválido"
    ]
  }),
  methods: {
    setConfirm() {
      if (this.$refs.form.validate()) {
        const payload = {
          cellphone: this.cellphone,
          value: this.$store.getters.getAmountToSet
        };
        this.$store.dispatch("chargeWithWalletE", payload);
      }
    }
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped>
.color-wallet {
  min-height: 80px;
  background-color: #26a69a;
  text-align: center;
  padding-top: 20px;
  display: block;
  font-size: 18px;
}
</style>
